// extracted by mini-css-extract-plugin
export default {"wrapper":"Reviews_wrapper__JrcZ0","title":"Reviews_title__FqDFF","Reviews":"Reviews_Reviews__vh5dR"};